import React from "react";
import {Col, Row} from "react-bootstrap";
import styled from "styled-components";
import {WerfenColorContrast, WerfenFormTextColor, White} from "../../Constants/ColorChart";

const ErrorBox = styled.div`
  color: ${White};
  background: ${WerfenColorContrast};
  margin-top: 2vh;
  text-align: center;
  font-size: 1.5em;
`;

const StyledParagraph = styled.p`
  border: none;
  width: 100%;
  color: ${WerfenFormTextColor};
  padding-left: 5%;
  padding-right: 5%;
  display: inline-block;
  padding-bottom: 2%;
  margin-right: 0px;
  font-size: 15px;
`;

type LoginErrorMessageProps = {
    message: string;
};

const LoginErrorMessage: React.FC<LoginErrorMessageProps> = ({message}) => {
    return (
        <Row>
            <Col lg={{span: 4, offset: 4}} xs={{span: 8, offset: 2}}>
                <ErrorBox>
                    <StyledParagraph>{message}</StyledParagraph>
                </ErrorBox>
            </Col>
        </Row>
    );
};

export default LoginErrorMessage;